const ALLOWED_KEYS = [
    'MembershipServicesManage',
    'SubscriptionServicesManage'
];

export const removeServiceFromManage = (state, serviceId, manageKey) => {
    if (!ALLOWED_KEYS.includes(manageKey)) return state;

    return {
        ...state,
        [manageKey]: state[manageKey].filter(
            item => item.service_id !== serviceId
        )
    };
};


